import * as React from "react";
import { Box, Typography, Chip, List, ListItem } from "@mui/material";
import type { DuplicateMatch } from "../../types";

export interface DuplicateMatchesListProps {
  /** Titolo/nome del file per cui sono stati trovati i duplicati. */
  fileLabel?: string;
  matches: DuplicateMatch[];
}

/** Elenco leggibile di documenti/Golden Standard potenzialmente duplicati, per i dialog di conferma. */
export const DuplicateMatchesList: React.FC<DuplicateMatchesListProps> = ({
  fileLabel,
  matches,
}) => {
  return (
    <Box>
      <Typography sx={{ mb: 1 }}>
        {fileLabel
          ? `Sono stati trovati possibili duplicati per "${fileLabel}":`
          : "Sono stati trovati possibili duplicati:"}
      </Typography>
      <List dense sx={{ bgcolor: "action.hover", borderRadius: 1, mb: 1 }}>
        {matches.map((m, i) => {
          const date = m.publication_date || m.date;
          const category = m.category_id || m.category;
          return (
            <ListItem key={i} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
              <Chip
                size="small"
                label={m.match_type === "hash" ? "Identico" : "Titolo simile"}
                color={m.match_type === "hash" ? "error" : "warning"}
                sx={{ mt: 0.25 }}
              />
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="body2" fontWeight={600} sx={{ wordBreak: "break-word" }}>
                  {m.title}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {[
                    category ? `Categoria: ${category}` : null,
                    date ? `Data: ${date}` : null,
                    m.score != null ? `Somiglianza: ${m.score}%` : null,
                  ]
                    .filter(Boolean)
                    .join(" · ")}
                </Typography>
              </Box>
            </ListItem>
          );
        })}
      </List>
      <Typography variant="body2" color="text.secondary">
        Vuoi procedere comunque con il caricamento?
      </Typography>
    </Box>
  );
};
